import { render, staticRenderFns } from "./ComicFrontPage.vue?vue&type=template&id=01c80a83&scoped=true&"
import script from "./ComicFrontPage.vue?vue&type=script&lang=js&"
export * from "./ComicFrontPage.vue?vue&type=script&lang=js&"
import style0 from "./ComicFrontPage.vue?vue&type=style&index=0&id=01c80a83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c80a83",
  null
  
)

export default component.exports